export default "__VITE_ASSET__f256f12d__"